<template>
  <div
    class="effect-setting setting-popup"
    v-if='boxData.judgeBox'
    :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex}"
    @mousedown.stop.prevent
  >
    <div
      class="setting-popup__drag-area"
      @mousedown="moveStart($event, true)"
      @mousemove="moveArea($event)"
      @mouseup="saveMoveState($event)" :style="{'cursor': 'move'}"
    >
      定制需求
    </div>

    <div class="settting-popup__content">

    </div>

    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
    <div class="setting-popup__mask" v-show="isShowMask"></div>
  </div>
</template>

<script>
import popup from '../mixins/popup.vue'

export default {
  mixins: [popup],
  components: {
  },
  data () {
    return {
      popupType: 'customWorks',
    }
  },
  watch: {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 258px;
  min-height: 180px;
  z-index: 35;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
    cursor: move;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding: 14px 0;
  }

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#ffffff, 0.7);
  }
}

.items {
  padding-top: 25px;
}

.items > .item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 14px;
  padding-right: 14px;
  margin-bottom: 25px;

  &__title {
    flex-shrink: 0;
    width: 56px;
    margin-right: 10px;
    text-align: left;
  }
}

.color {
  width: 75px;
  height: 30px;
  border-radius: 4px;
  background-color: #5779fa;
  cursor: pointer;
  box-shadow: 0 0 3px 0px rgba(0,0,0,0.5);
}

.dropdown {
  position: relative;
  &__select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 80px;
    height: 30px;
    line-height: 30px;
    border: solid 1px #f0f0f8;
    margin-left: 15px;
    cursor: pointer;
    text-align: left;
    padding-left: 12px;
    padding-right: 12px;
  }
  &__options {
    // position: absolute;
    z-index: 1;
    top: 120%;
    left: 15px;
    width: 80px;
    border: solid 1px #f0f0f8;
  }
  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    line-height: 24px;
    background-color: #fff;
    cursor: pointer;

    & > span:nth-child(1) {
      width: 25px;
      text-align: left;
      color: #9692a9;
    }
    &:hover, &.active {
      background-color: #f0f0f8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popupsNew/customWorks.vue